import React, { useState, useEffect, useMemo, useContext } from 'react';
import {formatDate, formatDateIntl} from '../../DateUtil'
import { LegacyStack} from '@shopify/polaris';
import SubscriptionRowCanvas from './SubscriptionRowCanvas'
import AddExtension from './AddExtension'
import AddOfficeHour from './AddOfficeHour'
import UpgradeFreeTrial from './UpgradeFreeTrial'
import UpgradeTempAccess from './UpgradeTempAccess'
import EditTransfer from './EditTransfer'
import EditAssigned from './EditAssigned'
import EditRetake from './EditRetake'
import EditRegisterRelated from './EditRegisterRelated'
import OfficeHourable from '../../concerns/OfficeHourable'
import Productable from '../../concerns/Productable'
import Subscriptionable from '../../concerns/Subscriptionable'
import Extendable from '../../concerns/Extendable'
import Reassignable from '../../concerns/Reassignable'
import Retakeable from '../../concerns/Retakeable'
import Transferable from '../../concerns/Transferable'
import RelatedRegisterable from '../../concerns/RelatedRegisterable'
import { CustomerContext } from '../../contexts/Customer'
import { ShopContext } from '../../contexts/Shop'
import { OfficeHoursContext } from '../../contexts/OfficeHours'
import { OfficeHourSubscriptionsContext } from '../../contexts/OfficeHourSubscriptions'
import { SectionsProvider } from '../../contexts/yolk/Sections'
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { HostContext } from '../../contexts/Host'
import { ProductsContext } from '../../contexts/Products'
import { LineItemsExtensionContext } from '../../contexts/LineItemsExtension'
import { SubscriptionCodesContext } from '../../contexts/SubscriptionCodes'
import { UserContext } from '../../contexts/yolk/User'

export default function SubscriptionRow(props) {
  const [customer] = useContext(CustomerContext)
  const [user] = useContext(UserContext)
  const shop_name = useContext(ShopContext)
  const subscriptions = useContext(SubscriptionsContext)
  const subscriptionCodes = useContext(SubscriptionCodesContext)
  const officeHourSubscriptions = useContext(OfficeHourSubscriptionsContext)
  const [officeHours] = useContext(OfficeHoursContext)
  const lineItemsExtension = useContext(LineItemsExtensionContext)
  const [products] = useContext(ProductsContext)
  const host = useContext(HostContext);

  const subscription = subscriptions.find((s) => s.id == props.id)
  if(!subscription) {
    throw Error(`no subscription found for id ${props.id} in : ${subscriptions.map((s) => s.id)}`)
  }
  const [saving, setSaving] = useState(false);
  const officeHourableFlags = OfficeHourable.flags(officeHourSubscriptions, subscription, officeHours, shop_name)
  const imageSrc = Productable.imageSrc(products, subscription)
  const title = subscription.title(products, subscriptionCodes)
  const assignedToText = Subscriptionable.assignedToText(subscription)
  const startAtText = Subscriptionable.startAtText(subscription, subscriptionCodes)
  const endAtText = Subscriptionable.endAtText(subscription, lineItemsExtension)
  const allowLoginAsStudentFlags = Subscriptionable.allowLoginAsStudentFlags(subscription, user)
  const extendableFlags = Extendable.flags(lineItemsExtension, subscription)
  const reassignableFlags = Reassignable.flags(subscription, subscriptionCodes, user)
  const retakeableFlags = Retakeable.flags(subscription, user)
  const transferableFlags = Transferable.flags(subscription, user)
  const relatedRegisterableFlags = RelatedRegisterable.flags(subscription, user)
  const goToCourseUrl = Subscriptionable.goToCourseUrl(subscription, lineItemsExtension, host, customer, shop_name)

  const isLegacy = subscription.isClassroom
  const isUserAssignedRegistration = subscription.isUserAssignedRegistration

  return (isLegacy && !isUserAssignedRegistration) ? (<tr className={`subscription-row ${saving ? 'subscription-row-saving' : ''} ${subscription.discount ? 'subscription-discounted' : ''} ${!relatedRegisterableFlags.length ? '' :  relatedRegisterableFlags}`}>
        <td className="thumbnail"><img src={imageSrc}/></td>
        <td>
          <span className="name">{title}</span>
          { !transferableFlags.length ?
            <div><EditTransfer subscription_id={subscription.id} onSaving={setSaving} /></div> :
            <div className={transferableFlags}></div>
          }
          { subscription.isFreeTrial ?
            <div className="free-trial">FREE TRIAL</div> : null
          }
        </td>
        <td className="start-at">{startAtText}</td>
        <td className="end-at">{endAtText}</td>
        <td className="assigned-to">{assignedToText}</td>
        <td className={subscription.error ? "error" : "goto-course"} colSpan={subscription.error ? 3 : 1}>
          {
            subscription.error || (goToCourseUrl ?
                <a className="goto-course-link" href={goToCourseUrl}>{subscription.status == 'delayed_start' ? 'Start' : 'Go To Course'}</a>
                 : Subscriptionable.goToCourseText(subscription, lineItemsExtension, subscriptionCodes))
          }
        </td>
        <td className="add-extension">
          { !extendableFlags.length ?
            <div><AddExtension enrollment_id={subscription.enrollmentId} course_name={title} /></div> : <div className={extendableFlags}></div>
          }
          { !officeHourableFlags.length ?
            <div><AddOfficeHour subscription_id={subscription.id} /></div> : <div className={officeHourableFlags}></div>
          }
          { !subscription.isUnassigned(subscriptionCodes) && subscription.isFreeTrial ?
            <div><UpgradeFreeTrial subscription_id={subscription.id} /></div> : null
          }
          { !subscription.isUnassigned(subscriptionCodes) && subscription.isTemp ?
            <div><UpgradeTempAccess subscription_id={subscription.id} /></div> : null
          }
        </td>
        { subscription.isUnassigned(subscriptionCodes) ?
          <td className="assign edit-assigned"><EditAssigned tabSelected="new" subscription_id={subscription.id}
          onSaving={setSaving} unassignedLinkText="Assign and Start" /></td> :
            !reassignableFlags.length ?
              <td className="reassign edit-assigned"><EditAssigned tabSelected="new" subscription_id={subscription.id} onSaving={setSaving}/></td> :
              <td className={`reassign ${reassignableFlags}`}></td>

        }
        { !retakeableFlags.length ?
          <td className="retake"><div><SectionsProvider><EditRetake
            id={subscription.enrollmentId}
            onSaving={setSaving}/>
          </SectionsProvider></div></td> :
          <td className={`retake ${retakeableFlags}`}></td>
        }
    </tr>) : <SubscriptionRowCanvas id={subscription.id} />
}
